module.exports = __webpack_public_path__ + "static/media/slider_img.9efff61f.svg";